import React from "react";
import PersonCardAiChat from "./PersonCardAiChat";

function ContactListContainerAI({ data }) {
  return (
    <div
      style={{
        height: "100%",
        overflowY: "auto",
        padding: "1.2rem 1rem",
      }}
      className="contact-ai-list-wrapper"
    >
      {/* Title Section */}
      <div
        style={{
          fontSize: "1.05rem",
          fontWeight: 600,
          marginBottom: "1rem",
          color: "#1A1A1A",
        }}
      >
        {data?.length} Contacts Found
      </div>

      {/* Flex Responsive Grid */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        {data?.map((person, index) => (
          <div
            key={person?._id || index}
            style={{
              flex: "1 1 240px", // minimum width of each card
              maxWidth: "320px", // optional: limit card max width
            }}
          >
            <PersonCardAiChat person={person} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactListContainerAI;
